class MPoint {
  constructor(x, y) {
    this.x = x;
    this.y = y;
  }
}

var MapionDatumUtil = {

  // 世界測地系用
  a: 6378137.0 /* 楕円体長半径 */ ,
  rf: 298.257223563 /* 扁平率逆数 */ ,
  e: 0.08181919084 /* Math.sqrt(2.0*rf - 1) / rf（第一離心率） */ ,
  // 東京測地系用
  a_t: 6377397.155 /* 楕円体長半径 */ ,
  rf_t: 299.152813 /* 扁平率逆数 */ ,
  e_t: 0.0816968312 /* 第一離心率 */ ,
  dx: -148.0,
  dy: 507.0,
  dz: 681.0,
  tky: {

    wgs: function(latlng) {
      var lon = latlng.x;
      var lat = latlng.y;
      var radt_lng = lon * Math.PI / 180;
      var radt_lat = lat * Math.PI / 180;
      var da = MapionDatumUtil.a - MapionDatumUtil.a_t;
      var df = 1.0 / MapionDatumUtil.rf - 1.0 / MapionDatumUtil.rf_t;
      var e2 = MapionDatumUtil.e_t * MapionDatumUtil.e_t;

      var adb = 1.0 - (1.0 / MapionDatumUtil.rf_t);

      var sb = Math.sin(radt_lat);
      var cb = Math.cos(radt_lat);
      var sl = Math.sin(radt_lng);
      var cl = Math.cos(radt_lng);
      var ssqlat = sb * sb;


      var rn = MapionDatumUtil.a_t / Math.sqrt(1.0 - e2 * ssqlat);
      var rm = MapionDatumUtil.a_t * (1.0 - e2) / Math.pow((1.0 - e2 * ssqlat), 1.5);
      var dlat = (((((-MapionDatumUtil.dx * sb * cl - MapionDatumUtil.dy * sb * sl) + MapionDatumUtil.dz * cb)
      + (da * ((rn * e2 * sb * cb) / MapionDatumUtil.a_t)))
      + (df * (rm * adb + rn / adb) * sb * cb)))
      / (rm);

      var dlng = (-MapionDatumUtil.dx * sl + MapionDatumUtil.dy * cl) / ((rn) * cb);
      var w_lat = (radt_lat + dlat) * 180 / Math.PI;
      var w_lng = (radt_lng + dlng) * 180 / Math.PI;

      return new MPoint(w_lng, w_lat);
    },
    tky: function(latlng) {
      return new MPoint(latlng.x, latlng.y);
    },
    jgd2000: function(latlng) {},
    Tokyo3p: function(latlng) {}
  },
  wgs: {
    wgs: function(latlng) {
      return new MPoint(latlng.x, latlng.y);
    },
    tky: function(latlng) {
      var radw_lat = latlng.y * Math.PI / 180;
      var radw_lng = latlng.x * Math.PI / 180;

      var da = MapionDatumUtil.a_t - MapionDatumUtil.a;
      var df = 1.0 / MapionDatumUtil.rf_t - 1.0 / MapionDatumUtil.rf;
      var e2 = MapionDatumUtil.e * MapionDatumUtil.e;
      var adb = 1.0 - (1.0 / MapionDatumUtil.rf);

      var sb = Math.sin(radw_lat);
      var cb = Math.cos(radw_lat);
      var sl = Math.sin(radw_lng);
      var cl = Math.cos(radw_lng);
      var ssqlat = sb * sb;

      var rn = MapionDatumUtil.a / Math.sqrt(1.0 - e2 * ssqlat);
      var rm = MapionDatumUtil.a * (1.0 - e2) / Math.pow((1.0 - e2 * ssqlat), 1.5);

      var dlat = (((((MapionDatumUtil.dx * sb * cl + MapionDatumUtil.dy * sb * sl) - MapionDatumUtil.dz * cb)
      + (da * ((rn * e2 * sb * cb) / MapionDatumUtil.a)))
      + (df * (rm * adb + rn / adb) * sb * cb)))
      / (rm);

      var dlng = (MapionDatumUtil.dx * sl - MapionDatumUtil.dy * cl) / ((rn) * cb);

      var t_lat = (radw_lat + dlat) * 180 / Math.PI;
      ;
      var t_lng = (radw_lng + dlng) * 180 / Math.PI;
      ;

      return new MPoint(t_lng, t_lat);

    },
    other: function(latlng) {
      return new MPoint(latlng.x, latlng.y);
    },
    jgd2000: function(latlng) {},
    Tokyo3p: function(latlng) {}
  },
  other: {
    tky: function(latlng) {
      return new MPoint(latlng.x, latlng.y);
    },
    wgs: function(latlng) {
      return new MPoint(latlng.x, latlng.y);
    },
    other: function(latlng) {
      return new MPoint(latlng.x, latlng.y);
    }
  }
}
export default MapionDatumUtil;